import React from "react";

const Warning = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.3337 8.99967C16.3337 4.94959 13.0504 1.66634 9.00033 1.66634C4.95024 1.66634 1.66699 4.94959 1.66699 8.99967C1.66699 13.0498 4.95024 16.333 9.00033 16.333C13.0504 16.333 16.3337 13.0498 16.3337 8.99967Z"
      stroke="#BD7100"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 7.54407C7 5.21074 11 4.8774 11 7.54407C11 9.21077 9 9.21077 9 10.5441"
      stroke="#BD7100"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <ellipse
      cx="8.99967"
      cy="12.6667"
      rx="0.666667"
      ry="0.666667"
      fill="#BD7100"
    />
  </svg>
);

Warning.propTypes = {};

export default Warning;
